import { Navigate, useParams } from "react-router-dom";
import { useSectionOperationsAccess } from "./useSectionOperationsAccess";

export default function OperationsIndex() {
  const { sectionId } = useParams();
  const { ready, showCommittees, showSectionOfficeFacilityTabs, showNotifications } =
    useSectionOperationsAccess(sectionId);

  if (!sectionId || !ready) {
    return null;
  }

  if (showCommittees) {
    return <Navigate to={`/sections/${sectionId}/operations/committees`} replace />;
  }

  if (showSectionOfficeFacilityTabs) {
    return <Navigate to={`/sections/${sectionId}/operations/employees`} replace />;
  }

  if (showNotifications) {
    return <Navigate to={`/sections/${sectionId}/operations/notifications`} replace />;
  }

  return <Navigate to={`/sections/${sectionId}/jobs`} replace />;
}
